import React from "react";
import Header from "./Header";

// Coquille commune aux pages "app" : header fixe + zone de contenu
// (padding haut pour le header, bas pour la barre "en lecture").
export default function AppLayout({ title, actions, children }) {
  return (
    <div className="min-h-screen bg-[#f7f9fc]">
      <Header />
      <main className="max-w-5xl mx-auto px-4 pt-24 pb-28">
        {(title || actions) && (
          <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
            {title && <h1 className="text-2xl font-bold text-gray-900">{title}</h1>}
            {actions}
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
